/**
 * Builds lead-form payloads from local JSON (same rules as former Next/Express API).
 * No HTTP — used by fetchLeadFormDataV2 in the browser.
 */
import cloneDeep from 'lodash/cloneDeep';
import { generateMessageId } from './utility';

import venueLeadForm from '../constants/leadform/venueFormOptions.json';
import venueLeadFormcorporate from '../constants/leadform/venueFormcorporateOptions.json';
import faridabadLandingPageFormOptions from '../constants/leadform/faridabadLandingPageFormOptions.json';
import makeupArtistForm from '../constants/leadform/makeupArtistOptions.json';
import makeupArtistFormTwo from '../constants/leadform/makeupArtistTwoOptions.json';
import leadFormConstants from '../constants/leadform/ncrLeadFormOptions.json';
import leadFormConstantsForWeddings from '../constants/leadform/ncrLeadFormWeddingCategoryOptions.json';
import leadFormConstantOther from '../constants/leadform/ncrLeadFormOptions.json';
import locationSlideOption from '../constants/leadform/locationSlideOption.json';
import gurgaonSubArea from '../constants/leadform/gurgaon_sub_areas.json';
import palwalSubArea from '../constants/leadform/palwal_sub_area.json';
import gurgaoncorporateSubArea from '../constants/leadform/gurgaon_corporate_sub_areas.json';
import noidaSubArea from '../constants/leadform/noida_sub_areas.json';
import delhiSubArea from '../constants/leadform/delhi_sub_areas.json';
import mumbaiSubArea from '../constants/leadform/mumbai_sub_areas.json';
import puneSubArea from '../constants/leadform/pune_sub_areas.json';
import goaSubArea from '../constants/leadform/goa_sub_areas.json';
import faridabadSubArea from '../constants/leadform/faridabad_sub_areas.json';
import ghaziabadSubArea from '../constants/leadform/ghaziabad_sub_areas.json';
import jaipurSubArea from '../constants/leadform/jaipur_sub_areas.json';
import pushkarSubArea from '../constants/leadform/pushkar_sub_area.json';
import destinationWeddingPreSlideOptions from '../constants/leadform/destinationWeddingPreSlides.json';
import destinationjaipurWeddingPreSlideOptions from '../constants/leadform/destinationJaipurWeddingPreSlides.json';
import regionSlideConst from '../constants/leadform/regionSlide.json';
import delhiRegion from '../constants/leadform/delhiRegionsOptions.json';
import includeOptionsForCities from '../constants/leadform/IncludeOptionsForCities.json';
import weddingVenueType from '../constants/leadform/weddingVenueTypeOptions.json';
import corporateVenueType from '../constants/leadform/corporateVenueTypeOptions.json';
import socialVenueType from '../constants/leadform/socialVenueTypeOptions.json';

const CATEGORY_WEDDING = 'wedding';
const CATEGORY_CORPORATE = 'corporate';
const CATEGORY_SOCIAL = 'social';
const VENUE_CORPORATE_STANALONE = 'venue_corporate_standalone';
const VENUE_CORPORATE_STANALONE_GURGAON = 'venue_corporate_standalone_gurgaon';

const CITY_LIST = [
  'Gurgaon',
  'gurgaon',
  'Noida',
  'noida',
  'Delhi',
  'delhi',
  'Goa',
  'goa',
  'faridabad',
  'Faridabad',
  'Ghaziabad',
  'ghaziabad',
  'jaipur',
  'Jaipur',
  'Mumbai',
  'mumbai',
  'Pune',
  'pune',
  'Pushkar',
  'pushkar',
  'Alwar',
  'alwar',
  'Palwal',
  'palwal',
];

const EXCEPTION_DELHI = 'delhi';
const EXCEPTION_MUMBAI = 'mumbai';

function newFormId() {
  return generateMessageId(12);
}

function getCitySubAreas(val) {
  const city = String(val).toLowerCase();
  switch (city) {
    case 'gurgaon':
      return gurgaonSubArea;
    case 'delhi':
      return delhiSubArea;
    case 'goa':
      return goaSubArea;
    case 'faridabad':
      return faridabadSubArea;
    case 'ghaziabad':
      return ghaziabadSubArea;
    case 'noida':
      return noidaSubArea;
    case 'mumbai':
      return mumbaiSubArea;
    case 'jaipur':
      return jaipurSubArea;
    case 'pune':
      return puneSubArea;
    case 'alwar':
      return jaipurSubArea;
    case 'palwal':
      return palwalSubArea;
    case 'pushkar':
      return pushkarSubArea;
    case 'gurgaoncorporate':
      return gurgaoncorporateSubArea;
    default:
      return [];
  }
}

function getRegions(val) {
  const city = String(val).toLowerCase();
  switch (city) {
    case 'gurgaon':
      return gurgaonSubArea;
    case 'delhi':
      return delhiRegion;
    case 'goa':
      return goaSubArea;
    case 'faridabad':
      return faridabadSubArea;
    case 'ghaziabad':
      return ghaziabadSubArea;
    case 'noida':
      return noidaSubArea;
    case 'mumbai':
      return mumbaiSubArea;
    case 'pune':
      return puneSubArea;
    case 'jaipur':
      return jaipurSubArea;
    case 'pushkar':
      return pushkarSubArea;
    case 'alwar':
      return jaipurSubArea;
    case 'palwal':
      return palwalSubArea;
    default:
      return [];
  }
}

function filterSubareasByCityAndEvent(city, event, cityEventSubareas, citySubareaDetails) {
  const c = String(city).toLowerCase();
  const e = String(event).toLowerCase();

  if (c === 'mumbai' || c === 'delhi') {
    return citySubareaDetails || [];
  }

  if (!cityEventSubareas[c] || !cityEventSubareas[c][e]) {
    return [];
  }

  const allowedSubareas = cityEventSubareas[c][e].subareas;
  const allowedSet = new Set(allowedSubareas.map((name) => name.toLowerCase()));

  return citySubareaDetails.filter((subarea) => {
    if (!subarea.label) return false;
    const labelNormalized = subarea.label.trim().toLowerCase();
    return allowedSet.has(labelNormalized);
  });
}

function createLocationSlide(optionsArray, city, eventType = 'wedding') {
  const filteredOptions = filterSubareasByCityAndEvent(city, eventType, includeOptionsForCities, optionsArray);
  return {
    _id: newFormId(),
    isNextBtnVisible: true,
    isPrevBtnVisible: true,
    isSkippingAllowed: false,
    isAutoSkipped: false,
    isContinuingSlide: false,
    isTriggerSlide: false,
    targetId: 'pef-location',
    questionText: 'Preferred Location',
    elements: [
      {
        isSearchAllowed: false,
        _id: 'element-id-location',
        isRequired: true,
        elementType: 'radio',
        keyName: 'location',
        icon: 'icon-vm-radio-black',
        selectedIcon: 'icon-vm-radio-active-black',
        options: filteredOptions,
        errorMessage: 'Please Select a Location',
        analyticsTriggerName: 'lead-form-location',
      },
    ],
  };
}

function getVenueType(category) {
  if (category && category.toLowerCase() === CATEGORY_WEDDING) {
    return weddingVenueType;
  }
  if (category && category.toLowerCase() === CATEGORY_CORPORATE) {
    return corporateVenueType;
  }
  if (category && category.toLowerCase() === 'social') {
    return socialVenueType;
  }
  return weddingVenueType;
}

function getUpdatedLeadFormConstant(category, excludedOptions, leadFormConstantsSource, city) {
  if (!category || !excludedOptions || !leadFormConstantsSource) return null;

  const venueType = cloneDeep(getVenueType(category));
  const venueTypeElement = venueType.elements.find((el) => el.keyName === 'venuetype');

  if (venueTypeElement) {
    venueTypeElement.options = venueTypeElement.options.filter(
      (option) => !excludedOptions.includes(option.value)
    );
  }

  const subAreas = getCitySubAreas(city);
  leadFormConstantsSource.slides.splice(0, 0, venueType);

  const c = String(city).toLowerCase();
  if (c !== 'alwar' && c !== 'palwal') {
    const locationSlide = createLocationSlide(subAreas, city, category);
    leadFormConstantsSource.slides.splice(1, 0, locationSlide);
  }

  return leadFormConstantsSource;
}

/**
 * @returns {{ status: 'Success', data: { id?: string, leadform: object } } | { status: 'Error', data: string }}
 */
export function buildLeadFormResponse(city, slideCode, category) {
  let formId = newFormId();

  if (slideCode === 'makeup-form') {
    return { status: 'Success', data: { leadform: makeupArtistForm } };
  }
  if (slideCode === 'destination-wedding-v1') {
    return { status: 'Success', data: { leadform: destinationWeddingPreSlideOptions } };
  }
  if (slideCode === 'jaipur-destination-wedding-v1') {
    return { status: 'Success', data: { leadform: destinationjaipurWeddingPreSlideOptions } };
  }
  if (slideCode === 'faridabad-stand-alone') {
    return { status: 'Success', data: { leadform: faridabadLandingPageFormOptions } };
  }
  if (slideCode === 'makeup-form-2') {
    return { status: 'Success', data: { leadform: makeupArtistFormTwo } };
  }
  if (slideCode === 'occasion-only') {
    return { status: 'Success', data: { leadform: venueLeadForm } };
  }
  if (slideCode === 'jaipur-and-bangalore-form') {
    return { status: 'Success', data: { leadform: venueLeadForm } };
  }
  if (slideCode === VENUE_CORPORATE_STANALONE) {
    return { status: 'Success', data: { leadform: venueLeadForm } };
  }
  if (slideCode === VENUE_CORPORATE_STANALONE_GURGAON) {
    const leadFormConstantGurgaon = cloneDeep(venueLeadFormcorporate);
    const gid = newFormId();
    leadFormConstantGurgaon._id = gid;
    const locationSlide = cloneDeep(locationSlideOption);
    const venueTypeSlide = cloneDeep(corporateVenueType);
    locationSlide.elements[0].options = getCitySubAreas('gurgaoncorporate');
    leadFormConstantGurgaon.slides.unshift(venueTypeSlide);
    leadFormConstantGurgaon.slides.unshift(locationSlide);
    return {
      status: 'Success',
      data: {
        id: gid,
        leadform: leadFormConstantGurgaon,
      },
    };
  }

  if (!city || !CITY_LIST.includes(String(city))) {
    return { status: 'Error', data: 'Requested City Data not available!' };
  }

  formId = newFormId();
  const catLower = category ? String(category).toLowerCase() : '';

  const isKnownCategory =
    catLower === CATEGORY_WEDDING || catLower === CATEGORY_CORPORATE || catLower === CATEGORY_SOCIAL;

  let leadFormConstant = null;

  if (isKnownCategory) {
    if (catLower === CATEGORY_WEDDING) {
      leadFormConstant = cloneDeep(leadFormConstantsForWeddings);
      leadFormConstant = getUpdatedLeadFormConstant(category, ['Banquet With Lawn'], leadFormConstant, city);
    } else if (catLower === CATEGORY_CORPORATE) {
      leadFormConstant = cloneDeep(leadFormConstants);
      leadFormConstant = getUpdatedLeadFormConstant(category, ['Farmhouse', 'Restaurant'], leadFormConstant, city);
    } else if (catLower === CATEGORY_SOCIAL) {
      leadFormConstant = cloneDeep(leadFormConstants);
      leadFormConstant = getUpdatedLeadFormConstant(
        category,
        ['Lawn', 'Rooftop', 'Banquet With Lawn'],
        leadFormConstant,
        city
      );
    }
    if (!leadFormConstant) {
      return { status: 'Error', data: 'Lead form build failed' };
    }
    leadFormConstant._id = formId;

    if (String(city).toLowerCase() === EXCEPTION_DELHI) {
      const regionSlide = cloneDeep(regionSlideConst);
      regionSlide.elements[0].options = getRegions(city);
      leadFormConstant.slides.unshift(regionSlide);
      leadFormConstant.slides.shift();
    }
    if (String(city).toLowerCase() === EXCEPTION_MUMBAI) {
      const locSlide = cloneDeep(locationSlideOption);
      locSlide.elements[0].options = getCitySubAreas(city);
      leadFormConstant.slides.unshift(locSlide);
      leadFormConstant.slides.shift();
    }
  } else {
    leadFormConstant = cloneDeep(leadFormConstantOther);
    leadFormConstant._id = formId;
    const locSlide = cloneDeep(locationSlideOption);
    locSlide.elements[0].options = getCitySubAreas(city);
    leadFormConstant.slides.unshift(locSlide);
  }

  return {
    status: 'Success',
    data: {
      id: formId,
      leadform: leadFormConstant,
    },
  };
}
